import { useEffect, useState } from "react";
import { Col, Container, Modal, Row, Button } from "react-bootstrap";
import { useLazyGetClientQuery, useLazyGetUserQuery, useLazyGetUserByIdQuery } from "../../libs/redux/slices/autocomxSlice/autocomxApiSlice";
import Loadingx from "../Loadingx/Loadingx";

const renderMetadataValue = (value, userNames = {}) => {
  if (value === null || value === undefined) return "";

  if (typeof value === 'object' && !Array.isArray(value) && value.hasOwnProperty('label')) {
    return value.label;
  }

  if (typeof value === 'string') {
    return userNames[value] || value;
  }

  if (Array.isArray(value)) {
    if (value.length > 0 && typeof value[0] === 'object') {
      if (value[0].hasOwnProperty('label')) {
        return value.map(item => item.label).join(", ");
      }
      if (value[0].hasOwnProperty('id')) {
        return value.map(item => item.id).join(", ");
      }
      if (value[0].hasOwnProperty('USRCONTR')) {
        return value.map(item => {
          const usrId = item.USRCONTR;
          return userNames[usrId] || usrId;
        }).join(", ");
      }
    }
    return JSON.stringify(value);
  }

  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

const Metadatx = ({ opMetada, setOpMetada, metadaSelc, setMetadaSelc, metadaMaqSelc }) => {
  const [findClients, { isLoading: isLoadingClients }] = useLazyGetClientQuery();
  const [findUsers, { isLoading: isLoadingUsers }] = useLazyGetUserQuery();
  const [findUserById, { isLoading: isLoadingUserById }] = useLazyGetUserByIdQuery();
  const [medadesc, setMetadesc] = useState(metadaSelc);
  const [finalMet, setFinalMet] = useState("");
  const [userNames, setUserNames] = useState({});
  useEffect(() => {
    if (Object.keys(metadaMaqSelc).length > 0) {
      const loadMetadesc = async () => {
        let aMetadat = Object.keys(metadaMaqSelc).map(el => {
          return el;
        })
        for (let i = 0; i <= aMetadat.length; i++) {
          switch (aMetadat[i]) {
            case "CLIIDXXX":
              await findClients('&filters[CLIIDXXX]=' + metadaMaqSelc["CLIIDXXX"])
                .then((response) => {
                  if (response?.data?.data?.data) {
                    let clinom = response.data.data.data.map((client) => {
                      return client.CLINOMXX;
                    });
                    setMetadesc({ ...medadesc, "CLIENTE NOMBRE": clinom[0] })
                  }
                })
                .catch(() => {
                });
              break;
            case "USRCONTR":
              const usrcontrValue = metadaMaqSelc["USRCONTR"];
              const newUserNames = { ...userNames };
              let usrIdsToSearch = [];

              if (Array.isArray(usrcontrValue)) {
                if (usrcontrValue.length > 0 && typeof usrcontrValue[0] === 'object') {
                  if (usrcontrValue[0].hasOwnProperty('label') || usrcontrValue[0].hasOwnProperty('id')) {
                    break;
                  }
                  usrIdsToSearch = usrcontrValue.map(item => item.USRCONTR).filter(id => id && !userNames[id]);
                }
              } else if (typeof usrcontrValue === 'string') {
                usrIdsToSearch = [usrcontrValue];
              }

              for (const usrId of usrIdsToSearch) {
                if (!userNames[usrId]) {
                  try {
                    const response = await findUserById(usrId);
                    if (response?.data?.data && response.data.data.length > 0) {
                      newUserNames[usrId] = `${response.data.data[0].USRIDXXX} - ${response.data.data[0].USRNOMXX}`;
                    } else {
                      newUserNames[usrId] = usrId;
                    }
                  } catch (error) {
                    newUserNames[usrId] = usrId;
                  }
                }
              }

              if (usrIdsToSearch.length > 0) {
                setUserNames(newUserNames);
              }
              break;
            default:
              break;
          }
        }
      }
      loadMetadesc();
    }
    // eslint-disable-next-line
  }, [])
  //useeffect para organizar metadatos
  useEffect(() => {
    if (medadesc !== "") {
      let organizar = Object.keys(medadesc).sort();
      let newObject = {};
      organizar.forEach(row => newObject[row] = medadesc[row])
      setFinalMet(newObject)
    }
  }, [medadesc])
  return (
    <>
      <Modal size="lg" show={opMetada} onHide={() => {
        setOpMetada(false)
        setMetadaSelc("")
      }}>
        <Modal.Header style={{ "backgroundColor": "#000000", "color": "white" }}>
          METADATOS
          <Button className="btn-close btn-close-white" aria-label="Close"
            onClick={() => {
              setOpMetada(false)
              setMetadaSelc("")
            }} />
        </Modal.Header>
        <Modal.Body>
          {isLoadingClients || isLoadingUsers || isLoadingUserById ? (
            <Loadingx
              width={50}
              height={50}
            />
          ) : (
            <Container>
              {
                Object.keys(finalMet).map(item => {
                  return (
                    <Row key={`itm_${item}`}>
                      <Col className="border-bottom border-dark d-grid justify-content-center">
                        {item}:
                      </Col>
                      <Col className="border-bottom border-dark d-grid justify-content-center">
                        {renderMetadataValue(finalMet[item], userNames)}
                      </Col>
                    </Row>
                  )
                })
              }
            </Container>
          )
          }
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Metadatx;
